module.exports = __webpack_public_path__ + "assets/img/pop-foto-desktop.d406d014.webp";